// Single source of truth: the canonical safety vocabularies (mirrored in COMS safetyVocab.ts, which the AI tools
// normalize against). This file previously carried its own copies that drifted from the canonical lists on five
// strings ('Ice / Winter Conditions', 'Oil / Petroleum Products', 'Poison / Toxins', 'Biological Diseases',
// 'Steel-Toed Boots'); values stored under those old strings still render, as custom chips.
import {
  ENVIRONMENTAL_HAZARDS,
  OTHER_HAZARDS,
  PHYSICAL_HAZARDS,
  REQUIRED_PPE,
} from 'components/IAP/initialResponsePage/SafetyAnalysis/types';

export const physicalHazardsOptions: string[] = [...PHYSICAL_HAZARDS];

export const environmentalHazardsOptions: string[] = [...ENVIRONMENTAL_HAZARDS];

export const otherHazardsOptions: string[] = [...OTHER_HAZARDS];

export const ppeOptions: string[] = [...REQUIRED_PPE];
